import React from 'react'
import { graphql, Link } from 'gatsby'
import Image from 'gatsby-image'

// Components
import Layout from 'components/Layout'
import SEO from 'components/SEO'
import Content from 'components/Content'

import Deliver from 'components/home/Deliver'
import Case from 'components/home/Case'
import About from 'components/home/About'
import VodCastsItems from '../components/VodCastItems'

import 'styles/HomeTemplate.scss'
import VodCastItem from '../components/Vodcast'
import Projects from '../components/Projects'
import BlogSlider from '../components/home/BlogSlider'

const Home = ({ data, location }) => {
  const { wordpressPage: page } = data
  const { allWordpressWpVodcasts: vodcasts } = data
  const { postsNL: posts } = data
  const {
    acf: { hero, deliver, klantcase, about, podyachts },
  } = page
  const url = location.href ? location.href : ''

  return (
    <Layout>
      <SEO
        yoast={{ meta: page.yoast_meta }}
        lang={page.wpml_current_locale.slice(0, 2)}
        location={url}
      />
      <div className="home-page">
        <section className="hero">
          <Image
            loading="eager"
            fadeIn={false}
            fluid={hero.image.localFile.childImageSharp.fluid}
            className="hero-image"
          />
          <div className="container hero-text">
            <div className="col-lg-8 col-xl-6">
              <h1>
                <Content className="with-dot-nested" content={hero.text} />
              </h1>
            </div>
          </div>
          <div className="container hero-column d-flex">
            <div className="row justify-content-end align-items-end">
              <div className="col-md-10 col-lg-8 col-xl-6 card d-block">
                <h2 className="with-dot mb-4">{hero.block.title}</h2>
                <Content className="mb-4" content={hero.block.content} />
                <Link className="button" to={hero.block.cta.relations.path}>
                  {hero.block.cta.label}
                </Link>
              </div>
            </div>
          </div>
        </section>

        <Deliver deliver={deliver} />
        <Case klantcase={klantcase} />
        <About about={about} />

        {page.wpml_current_locale === 'nl_NL' && (
          <section className="vodcasts position-relative overflow-hidden mb-5">
            <Image
              loading="eager"
              fadeIn={false}
              fluid={podyachts.image.localFile.childImageSharp.fluid}
              className="vodcasts-image"
            />
            <div className="container h-100">
              <div className="row align-items-end h-100">
                <div className="col-md-12 card blog-slider-card pt-5 px-3">
                  <BlogSlider
                    title={page.acf.podyachts.title}
                    posts={posts.edges
                      .filter(
                        ({ node }) =>
                          node.acf?.banner?.localFile?.childImageSharp?.fixed
                      )
                      .map(({ node }) => node)}
                  />
                </div>
              </div>
            </div>
          </section>
        )}
        {/* <Blog projecten={projecten} /> */}
      </div>
    </Layout>
  )
}

export default Home

export const query = graphql`
  query ($wordpress_id: Int!) {
    wordpressPage(wordpress_id: { eq: $wordpress_id }) {
      id
      wordpress_id
      title
      slug
      content
      wpml_current_locale
      yoast_meta {
        name
        content
        property
      }
      acf {
        # Hero section
        hero {
          text
          block {
            content
            title
            cta {
              label
              relations {
                path
              }
            }
          }
          image {
            localFile {
              childImageSharp {
                fluid(quality: 90, maxWidth: 1920) {
                  ...GatsbyImageSharpFluid_withWebp_noBase64
                }
              }
            }
          }
        }

        # Deliver section
        deliver {
          title
          functions {
            name
            image {
              localFile {
                childImageSharp {
                  fluid(quality: 100, maxWidth: 500) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
          before_cta
          cta {
            label
            relations {
              path
            }
          }
          background {
            localFile {
              childImageSharp {
                fluid(quality: 100, maxWidth: 1529) {
                  ...GatsbyImageSharpFluid_withWebp_noBase64
                }
              }
            }
          }
        }

        # Klantcase section
        klantcase: case {
          background {
            localFile {
              childImageSharp {
                fluid(quality: 100, maxWidth: 1440) {
                  ...GatsbyImageSharpFluid_withWebp_noBase64
                }
              }
            }
          }
          cta
          relations {
            slug
            path
            acf {
              quote {
                content
                quoted_person {
                  name
                  function
                }
              }
            }
          }
        }

        # About section
        about {
          title
          columns {
            title
            content
          }
          cta {
            label
            relations {
              path
            }
          }
        }

        podyachts {
          title
          description
          image {
            localFile {
              childImageSharp {
                fluid(quality: 100, maxWidth: 2000) {
                  ...GatsbyImageSharpFluid_withWebp_noBase64
                }
              }
            }
          }
        }

        # Blog - projecten section
        # projecten {
        #   title
        #   cta
        #   cta_overview {
        #     label
        #     relations {
        #       path
        #     }
        #   }
        #   relations {
        #     title
        #     path
        #     excerpt
        #     slug
        #     acf {
        #       subtitle
        #       banner {
        #         localFile {
        #           childImageSharp {
        #             fluid(quality: 100, maxWidth: 1440) {
        #               ...GatsbyImageSharpFluid_withWebp
        #             }
        #           }
        #         }
        #       }
        #     }
        #   }
        # }
      }
    }

    postsNL: allWordpressPost(
      filter: {
        status: { eq: "publish" }
        wpml_current_locale: { eq: "nl_NL" }
      }
    ) {
      edges {
        node {
          title
          path
          acf {
            banner {
              localFile {
                childImageSharp {
                  fixed(quality: 100, width: 340, height: 318) {
                    ...GatsbyImageSharpFixed_withWebp
                  }
                }
              }
            }
          }
        }
      }
    }

    allWordpressWpVodcasts(limit: 2, sort: { fields: date, order: ASC }) {
      edges {
        node {
          title
          path
          id
          acf {
            title
            length_vodcast
            speakers
            image {
              localFile {
                childImageSharp {
                  fluid(quality: 99, maxWidth: 400) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
